import usePlaygroundAtom from '../../../../stores/playground/playgroundStore'
import usePlaygroundAction from '../../../../stores/playground/usePlaygroundAction'

const useAtomPlayground = () => {
    const playgroundStore = usePlaygroundAtom()
    const playgroundAction = usePlaygroundAction()

    const handleClickSetFirstName = () => {
        playgroundAction.setFirstName(`Chanon`)
    }
    return {
        onClickSetFirstName: handleClickSetFirstName,
        playgroundStore,
    }
}

export default useAtomPlayground
